import { useMutation, UseMutationOptions } from 'react-query';
import { APIError } from '~/src/utils/error';
import { useCurrentOrgFprint } from '../../user';
import { fieldMappingService } from '../services';
import type { EntityType } from '~/src/entities/project/types';

type MarkCoreFieldModifiedVariables = {
  entityType: EntityType.CONTACT;
  entityId: number;
  fieldName: string;
};

type MarkCoreFieldModifiedResponse = {
  success: boolean;
};

export const useMarkCoreFieldModified = (
  options: UseMutationOptions<
    MarkCoreFieldModifiedResponse,
    APIError,
    MarkCoreFieldModifiedVariables
  > = {},
) => {
  const orgFprint = useCurrentOrgFprint();

  return useMutation<
    MarkCoreFieldModifiedResponse,
    APIError,
    MarkCoreFieldModifiedVariables
  >({
    mutationFn: ({ entityType, entityId, fieldName }) =>
      fieldMappingService.markCoreFieldModified(
        orgFprint,
        entityType,
        entityId,
        fieldName,
      ),
    onSuccess: options.onSuccess,
    onError: (err, variables, context) => {
      // Log error but don't block user - this is a fire-and-forget operation
      console.error('Failed to mark core field as modified:', err);
      options.onError?.(err, variables, context);
    },
  });
};
